package se.mittpass.shared.config

import kotlinx.browser.window

/**
 * Same-origin API base so Bearer auth and cookies behave consistently.
 * Webpack devServer proxies API paths to Ktor :8080 (see web/webpack.config.d/devServer.js).
 * Docker/nginx proxies the same prefixes (nginx/default.conf).
 */
actual fun apiBaseUrl(): String =
    "${window.location.protocol}//${window.location.host}/"
